import { $api } from "../AxiosInstance";

export class AuthService {
  /**
   * Login user
   * @param {String} username
   * @param {String} password
   * @returns {Promise<Boolean>}
   */
  static async login(username, password) {
    return await $api
      .post("/api/login", null, { params: { username, password } })
      .then((req) => {
        try {
          return req.status === 200;
        } catch (e) {
          return false;
        }
      })
      .catch(() => {
        return false;
      });
  }

  /**
   * Logout user
   * @returns {Promise<Boolean>}
   */
  static async logout() {
    return await $api
      .get("/api/logout")
      .then(() => true)
      .catch(() => false);
  }

  /**
   * Create default user
   * @param {String} email
   * @param {String} password
   */
  static async createDefaultUser(email, password) {
    return await $api.post("/api/users/createDefaultUser", { email, password });
  }

  /**
   * Create account/admin user
   * @param {String} email
   * @param {String} password
   */
  static async createAccount(email, password) {
    return await $api.post("/api/users/createAdminUser", { email, password });
  }

  /**
   * Save token
   * @param {String} email
   * @param {String} token
   */
  static async saveToken(email, token) {
    return await $api.put("/api/save/token", {
      email,
      token,
    });
  }
}
